// extracted by mini-css-extract-plugin
export var laptop = "video-module--laptop--3b--W";
export var laptopImage = "video-module--laptopImage--xxEN4";
export var playButton = "video-module--playButton--48rmr";
export var player = "video-module--player--MSlRJ";
export var preview = "video-module--preview--VWxpN";
export var sbShowMain = "video-module--sb-show-main--of9vS";